import React from 'react'
import './NavBarTile.scss'
import Loader from '../../../UI/Loader/Loader'

export interface NavBarTileProps {
    name: string;
    time: any;
    isActive: boolean;
    isComplete: boolean;
    navUrl: string;
    logo: string;
    logoNew?:string;
    isClickable?: boolean,
    isLoading?: boolean
    onNavTileClick: () => void
}

const NavBarTile: React.FC<NavBarTileProps> = (props) => {
    return (
        <div
            className={'navBarTile' + (props.isActive ? ' active' : '') + (props.isComplete ? ' op05' : '') + (!props.isClickable ? ' non-clickble' : '')}
            role={props.isClickable === false ? undefined : 'button'}
            tabIndex={props.isClickable === false ? -1 : 0}
            aria-current={props.isActive ? 'page' : undefined}
            aria-disabled={props.isClickable === false || undefined}
            onClick={props.onNavTileClick}
            onKeyDown={(e) => {
                if (props.isClickable === false) return;
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    props.onNavTileClick();
                }
            }}
        >
            <div className='tileContent'>
                <div className='prflNavTileLogo'>
                    {/* <span className='edel-icon-clock' /> */}
                    <img src={props.isActive && !props.isComplete?props.logoNew:props.logo} alt="" aria-hidden="true" />
                </div>
                <div className='navBarLabel'>
                    <div className='navBarHead'>
                        <span className='navBarHeading'>{props.name}</span>
                    </div>
                    <div className='navBarInfo'>
                        {
                            props.isLoading ?
                                <Loader size={18} />
                                :
                                props.isComplete ?
                                    <>
                                        <span className='edel-icon-tick' aria-hidden="true" />
                                        <span className='infoComp'>Completed</span>
                                    </>
                                    :
                                    <span className={'navBarInfoLbl' + (props.isActive ? ' blue' : '')}>
                                        {props.isActive ? 'In Progress' : props.time}
                                    </span>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default NavBarTile;